module.exports = "<nv-icon [name]=\"iconName\"></nv-icon> <span class=\"nv-note-content\"> <ng-content #textContent></ng-content> </span>\n"